<template>
  <img
    :src="path"
    alt=""
    class="image"
  >
</template>

<script>

export default {
  name: 'Products',
  props: {
    path: String
  }
}
</script>

<style scoped lang="scss">
.image {
  width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
}

// @media (min-width: 992px) {
//   .product-info {
//     margin-top: 50px;
//     font-size: 2rem;
//     color: gray;
//   }
// }
</style>
